import React, { useRef, useState } from "react";
import banner from "../Assets/Images/homebanner.jpg";
import bgbanner from "../Assets/Images/bg-banner.png";
import { Link, useNavigate } from "react-router-dom";
import OwlCarousel from "react-slick";
import loan from "../Assets/Images/loan.png";
import callcenter from "../Assets/Images/call-center.png";
import deliverytruck from "../Assets/Images/delivery-truck.png";
import dress from "../Assets/Images/dress.png";
import electronics from "../Assets/Images/electronics.png";
import furnitures from "../Assets/Images/furniture.png";
import graduation from "../Assets/Images/graduation.png";
import heart from "../Assets/Images/heart.png";
import makeover from "../Assets/Images/makeover.png";
import workspace from "../Assets/Images/workspace.png";
import store from "../Assets/Images/store.png";
import sketch from "../Assets/Images/sketch.png";
import aboutdescription from "../Assets/Images/aboutdescription.jpg";
function Home() {
  const navigate = useNavigate();
  const catRef = useRef();
  const [selectCategories, setselectCategories] = useState("freelancer");
  const [searchText, setsearchText] = useState("");
  const [location, setLocation] = useState("");
  const keywordRef = useRef(null);
  const images = ['ads11.png', 'ads12.png', 'ads2.png'];
  var settings = {
    dots: false,
    autoplay: true,
    autoplaySpeed: 5000,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  const CustomArrow = (props) => {
    return (
      <div
        {...props}
        style={{
          backgroundColor: "violet",
          color: "white",
          height: 40,
          width: 40,
          borderRadius: 20,
          paddingTop: 10,
          textAlign: "center",
          verticalAlign: "middle",
        }}
      />
    );
  };
  const showContent = (divid, btnid) => {
    const content = document.getElementById(divid);
    const readMoreButton = document.getElementById(btnid);
    content.classList.toggle("expanded");
    if (content.classList.contains("expanded")) {
      readMoreButton.textContent = "Read Less";
    } else {
      readMoreButton.textContent = "Read More";
    }
  };
  const openUrl = (_txt) => {
    let url = "/allproviders";
    let obj = {};
    if (selectCategories) {
      obj.category = selectCategories;
    }
    if (searchText || _txt) {
      obj.txt = _txt || searchText;
    }
    if (location) {
      obj.location = location;
    }
    const queryString = new URLSearchParams(obj).toString();
    if (queryString) {
      url += "?" + queryString;
    }
    console.log(url);
    return url;
  };
  return (
    <>
      <section
        className="banner-1 cover-image sptb-4 sptb-tab bg-background33"
        style={{ background: `url(${banner}) center center` }}
      >
        <div className="header-text text mb-0 pb-5">
          <div className="container">
            <div className="text-center text-white ">
              <h1 className="" style={{ fontWeight: "bold", paddingTop: 50 }}>
                The Global Marketing Platform
                Connecting Businesses and Marketers
              </h1>
              {/* <p style={{ fontWeight: "bold", fontSize: 18 }}>
                With thousands of users, we just have the right one for you
              </p> */}
            </div>
            <div className="row">
              <div className="col-xl-10 col-lg-12 col-md-12 d-block mx-auto">
                <div className="item-search-tabs">
                  {/* <div className="item-search-menu">
                    <ul className="nav">
                      <li className="">
                        <a
                          href="#"
                          class={
                            selectCategories === "freelancer"
                              ? "bg-primary active"
                              : ""
                          }
                          style={{ fontWeight: "bold" }}
                          onClick={(e) => {
                            e.preventDefault();
                            setselectCategories("freelancer");
                          }}
                        >
                          Freelance Marketer
                        </a>
                      </li>
                      <li>
                        <a
                          href="#"
                          class={
                            selectCategories === "provider"
                              ? "bg-primary active"
                              : ""
                          }
                          style={{ fontWeight: "bold" }}
                          onClick={(e) => {
                            e.preventDefault();
                            setselectCategories("provider");
                          }}
                        >
                          Business
                        </a>
                      </li>
                    </ul>
                  </div> */}
                  <div className="tab-content index-search-select">
                    <div className="tab-pane active">
                      <div className=" search-background bg-transparent">
                        <form
                          onSubmit={(e) => {
                            e.preventDefault();
                            navigate(
                              `/allproviders?category=${selectCategories}&txt=${searchText || ""
                              }&location=${location || ""}`
                            );
                          }}
                          className="form row g-0"
                        >
                          <div className="form-group col-xl-12 col-lg-12  col-md-12 mb-0 location">
                            <div className="row g-0 br-0">
                              {/* <div className="form-group  col-xl-4 col-lg-3 col-md-12 mb-0 bg-white ">
                                  <select
                                    type="text"
                                    className="form-control border-start-0"
                                    id="employe-text"
                                    value={selectCategories}
                                    onChange={(e) =>
                                      setselectCategories(e.target.value)
                                    }
                                  >
                                    <option value={""}>
                                      -- Select Category --
                                    </option>
                                    <option value={"freelancer"}>
                                      Freelance Marketer / Business Developer
                                    </option>
                                    <option value={"provider"}>
                                      Business
                                    </option>
                                  </select>
                                </div> */}
                              <div className="fa-select-wrapper form-group  col-xl-3 col-lg-3 col-md-12 mb-0 bg-white ">
                                <select
                                  type="text"
                                  className="form-control custom-select"
                                  id="subcategoryselect"
                                  value={selectCategories}
                                  ref={catRef}
                                  tabIndex={0}
                                  onChange={(e) =>
                                    setselectCategories(e.target.value)
                                  }
                                >
                                  <option value={"freelancer"}>
                                    Freelance Marketer
                                  </option>
                                  <option value={"provider"}>
                                    Businesses
                                  </option>
                                </select>
                                {/* <span>
                                    <i
                                      onClick={() => {
                                        let ele = document.getElementById("subcategoryselect");
                                        if (ele) {
                                          ele.focus();
                                          ele.click();
                                        }
                                      }}
                                      class="fa fa-caret-down location-gps me-1"
                                    ></i>
                                  </span> */}
                              </div>
                              <div className="form-group  col-xl-3 col-lg-3 col-md-12 mb-0 bg-white ">
                                <input
                                  type="text"
                                  className="form-control border-start-0"
                                  id="employe-text"
                                  placeholder="Enter location"
                                  value={location}
                                  onChange={(e) => setLocation(e.target.value)}
                                />
                                <span>
                                  <i class="fa fa-map-marker location-gps me-1"></i>
                                </span>
                              </div>
                              <div className="form-group  col-xl-4 col-lg-3 col-md-12 mb-0 bg-white ">
                                <input
                                  ref={keywordRef}
                                  type="text"
                                  className="form-control border-start-0"
                                  id="employe-text"
                                  placeholder="Enter industry e.g., Real estate, Healthcare, Education...."
                                  value={searchText}
                                  onChange={(e) =>
                                    setsearchText(e.target.value)
                                  }
                                />
                              </div>
                              <div className="col-xl-2 col-lg-3 col-md-12 mb-0">
                                <button
                                  type="submit"
                                  className="btn btn-block btn-primary fs-14"
                                >
                                  <i className="fa fa-search"></i> Search
                                </button>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="sptb bg-white">
        <div class="container">
          <div className="row">
            <div
              className="col-lg-12 mt-5"
              style={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div class="section-title mt-auto">
                <h1 className="text-black text-center" style={{ fontWeight: "bold" }}>
                  The Future of Marketing is Here
                </h1>
                <h3 className="mb-5 text-center">Welcome to Happie Dealz — where businesses and freelance marketers connect through direct
                  partnerships.</h3>
                <h2 className="text-black text-center" style={{ fontWeight: "bold" }}>Get contacts in all these industries and more!</h2>
              </div>
              <div
                class="row"
                style={{
                  border: "1px solid black",
                  borderRadius: 10,
                  paddingTop: 20,
                  marginTop: "auto",
                  overflowY: "auto",
                  maxHeight: 500,
                }}
              >
                <p className="text-center mb-2">
                  Get connected to all these and more!
                </p>
                <div class="col-xl-2 col-lg-2 col-md-4 col-sm-6 col-xs-6">
                  <div class="card bg-card-light">
                    <div class="card-body p-2">
                      <div class="cat-item text-center">
                        <Link to={openUrl("Retail and E-Commerce")}></Link>
                        <div class="cat-img">
                          <img
                            src={require("../Assets/Images/online-store.png")}
                            alt="img"
                          />
                        </div>
                        <div class="cat-desc mt-1">
                          <h6 class="mb-1">Retail and E-Commerce</h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-xl-2 col-lg-2 col-md-4 col-sm-6 col-xs-6">
                  <div class="card bg-card-light">
                    <div class="card-body p-2">
                      <div class="cat-item text-center">
                        <Link to={openUrl("Technology and Software")}></Link>
                        <div class="cat-img">
                          <img src={workspace} alt="img" />
                        </div>
                        <div class="cat-desc mt-1">
                          <h6 class="mb-1">Technology and Software</h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-xl-2 col-lg-2 col-md-4 col-sm-6 col-xs-6">
                  <div class="card bg-card-light">
                    <div class="card-body p-2">
                      <div class="cat-item text-center">
                        <Link to={openUrl("Healthcare")}></Link>
                        <div class="cat-img">
                          <img src={heart} alt="img" />
                        </div>
                        <div class="cat-desc mt-1">
                          <h6 class="mb-1">Healthcare</h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-xl-2 col-lg-2 col-md-4 col-sm-6 col-xs-6">
                  <div class="card bg-card-light">
                    <div class="card-body p-2">
                      <div class="cat-item text-center">
                        <Link to={openUrl("Finance and Banking")}></Link>
                        <div class="cat-img text-shadow1">
                          <img
                            src={require("../Assets/Images/provider.png")}
                            alt="img"
                          />
                        </div>
                        <div class="cat-desc mt-1">
                          <h6 class="mb-1">Finance and Banking</h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-xl-2 col-lg-2 col-md-4 col-sm-6 col-xs-6">
                  <div class="card bg-card-light">
                    <div class="card-body p-2">
                      <div class="cat-item text-center">
                        <Link to={openUrl("Real Estate")}></Link>
                        <div class="cat-img">
                          <img src={loan} alt="img" />
                        </div>
                        <div class="cat-desc mt-1">
                          <h6 class="mb-1">Real Estate</h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-xl-2 col-lg-2 col-md-4 col-sm-6 col-xs-6">
                  <div class="card bg-card-light">
                    <div class="card-body p-2">
                      <div class="cat-item text-center">
                        <Link to={openUrl("Travel and Hospitality")}></Link>
                        <div class="cat-img">
                          <img
                            src={require("../Assets/Images/airplane.png")}
                            alt="img"
                          />
                        </div>
                        <div class="cat-desc mt-1">
                          <h6 class="mb-1">Travel and Hospitality</h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-xl-2 col-lg-2 col-md-4 col-sm-6 col-xs-6">
                  <div class="card bg-card-light">
                    <div class="card-body p-2">
                      <div class="cat-item text-center">
                        <Link to={openUrl("Education and E-Learning")}></Link>
                        <div class="cat-img">
                          <img src={graduation} alt="img" />
                        </div>
                        <div class="cat-desc mt-1">
                          <h6 class="mb-1">Education and E-Learning</h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-xl-2 col-lg-2 col-md-4 col-sm-6 col-xs-6">
                  <div class="card bg-card-light">
                    <div class="card-body p-2">
                      <div class="cat-item text-center">
                        <Link to={openUrl("Automotive")}></Link>
                        <div class="cat-img">
                          <img
                            src={require("../Assets/Images/automotive.png")}
                            alt="img"
                          />
                        </div>
                        <div class="cat-desc mt-1">
                          <h6 class="mb-1">Automotive</h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-xl-2 col-lg-2 col-md-4 col-sm-6 col-xs-6">
                  <div class="card bg-card-light">
                    <div class="card-body p-2">
                      <div class="cat-item text-center">
                        <Link to={openUrl("Entertainment and Media")}></Link>
                        <div class="cat-img">
                          <img src={electronics} alt="img" />
                        </div>
                        <div class="cat-desc mt-1">
                          <h6 class="mb-1">Entertainment and Media</h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-xl-2 col-lg-2 col-md-4 col-sm-6 col-xs-6">
                  <div class="card bg-card-light">
                    <div class="card-body p-2">
                      <div class="cat-item text-center">
                        <Link to={openUrl("Food and Beverages")}></Link>
                        <div class="cat-img">
                          <img
                            src={require("../Assets/Images/taco.png")}
                            alt="img"
                          />
                        </div>
                        <div class="cat-desc mt-1">
                          <h6 class="mb-1">Food and Beverages</h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-xl-2 col-lg-2 col-md-4 col-sm-6 col-xs-6">
                  <div class="card bg-card-light">
                    <div class="card-body p-2">
                      <div class="cat-item text-center">
                        <Link to={openUrl("Fashion and Beauty")}></Link>
                        <div class="cat-img">
                          <img src={makeover} alt="img" />
                        </div>
                        <div class="cat-desc mt-1">
                          <h6 class="mb-1">Fashion and Beauty</h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-xl-2 col-lg-2 col-md-4 col-sm-6 col-xs-6">
                  <div class="card bg-card-light">
                    <div class="card-body p-2">
                      <div class="cat-item text-center">
                        <Link
                          to={openUrl("Construction and Infrastructure")}
                        ></Link>
                        <div class="cat-img">
                          <img src={sketch} alt="img" />
                        </div>
                        <div class="cat-desc mt-1">
                          <h6 class="mb-1">Construction and Infrastructure</h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-xl-2 col-lg-2 col-md-4 col-sm-6 col-xs-6">
                  <div class="card bg-card-light">
                    <div class="card-body p-2">
                      <div class="cat-item text-center">
                        <Link to={openUrl("Energy and Utilities")}></Link>
                        <div class="cat-img">
                          <img
                            src={require("../Assets/Images/utilities.png")}
                            alt="img"
                          />
                        </div>
                        <div class="cat-desc mt-1">
                          <h6 class="mb-1">Energy and Utilities</h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-xl-2 col-lg-2 col-md-4 col-sm-6 col-xs-6">
                  <div class="card bg-card-light">
                    <div class="card-body p-2">
                      <div class="cat-item text-center">
                        <Link to={openUrl("Non-Profit and Charity")}></Link>
                        <div class="cat-img text-shadow1">
                          <img
                            src={require("../Assets/Images/helping-hand.png")}
                            alt="img"
                          />
                        </div>
                        <div class="cat-desc mt-1">
                          <h6 class="mb-1">Non-Profit and Charity</h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-xl-2 col-lg-2 col-md-4 col-sm-6 col-xs-6">
                  <div class="card bg-card-light">
                    <div class="card-body p-2">
                      <div class="cat-item text-center">
                        <Link to={openUrl("Sports and Fitness")}></Link>
                        <div class="cat-img">
                          <img
                            src={require("../Assets/Images/sport.png")}
                            alt="img"
                          />
                        </div>
                        <div class="cat-desc mt-1">
                          <h6 class="mb-1">Sports and Fitness</h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-xl-2 col-lg-2 col-md-4 col-sm-6 col-xs-6">
                  <div class="card bg-card-light">
                    <div class="card-body p-2">
                      <div class="cat-item text-center">
                        <Link to={openUrl("Agriculture and Farming")}></Link>
                        <div class="cat-img">
                          <img
                            src={require("../Assets/Images/sprout.png")}
                            alt="img"
                          />
                        </div>
                        <div class="cat-desc mt-1">
                          <h6 class="mb-1">Agriculture and Farming</h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-xl-2 col-lg-2 col-md-4 col-sm-6 col-xs-6">
                  <div class="card bg-card-light">
                    <div class="card-body p-2">
                      <div class="cat-item text-center">
                        <Link to={openUrl("Telecommunications")}></Link>
                        <div class="cat-img">
                          <img
                            src={require("../Assets/Images/space-station.png")}
                            alt="img"
                          />
                        </div>
                        <div class="cat-desc mt-1">
                          <h6 class="mb-1">Telecommunications </h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-xl-2 col-lg-2 col-md-4 col-sm-6 col-xs-6">
                  <div class="card bg-card-light">
                    <div class="card-body p-2">
                      <div class="cat-item text-center">
                        <Link to={openUrl("Legal Services")}></Link>
                        <div class="cat-img">
                          <img src={callcenter} alt="img" />
                        </div>
                        <div class="cat-desc mt-1">
                          <h6 class="mb-1">Legal Services</h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-xl-2 col-lg-2 col-md-4 col-sm-6 col-xs-6">
                  <div class="card bg-card-light">
                    <div class="card-body p-2">
                      <div class="cat-item text-center">
                        <Link
                          to={openUrl("Logistics and Transportation")}
                        ></Link>
                        <div class="cat-img">
                          <img src={deliverytruck} alt="img" />
                        </div>
                        <div class="cat-desc mt-1">
                          <h6 class="mb-1">Logistics and Transportation</h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-xl-2 col-lg-2 col-md-4 col-sm-6 col-xs-6">
                  <div class="card bg-card-light">
                    <div class="card-body p-2">
                      <div class="cat-item text-center">
                        <Link to={openUrl("Fashion and Lifestyle")}></Link>
                        <div class="cat-img">
                          <img src={dress} alt="img" />
                        </div>
                        <div class="cat-desc mt-1">
                          <h6 class="mb-1">Fashion and Lifestyle</h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-xl-2 col-lg-2 col-md-4 col-sm-6 col-xs-6">
                  <div class="card bg-card-light">
                    <div class="card-body p-2">
                      <div class="cat-item text-center">
                        <Link to={openUrl("Franchises")}></Link>
                        <div class="cat-img">
                          <img src={store} alt="img" />
                        </div>
                        <div class="cat-desc mt-1">
                          <h6 class="mb-1">Franchises</h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-xl-2 col-lg-2 col-md-4 col-sm-6 col-xs-6">
                  <div
                    class="card bg-card-light"
                    onClick={() => {
                      if (keywordRef.current) {
                        keywordRef.current.focus();
                      }
                    }}
                  >
                    <div class="card-body p-2">
                      <div class="cat-item text-center">
                        {/* <Link to={"/allproviders?category=${selectCategories}&Health"}></Link> */}
                        <div class="cat-img">
                          <img src={furnitures} alt="img" />
                        </div>
                        <div class="cat-desc mt-1">
                          <h6 class="mb-1">Others</h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 mx-auto mt-5 d-flex justify-content-center">
              <img
                src={bgbanner}
                className=" mt-2"
                style={{ borderRadius: 20, height: '100%', overflow: "hidden", maxHeight: 400 }}
              />
            </div>
            <div className="col-lg-8 mt-5 ms-auto">
              <div className="container">
                <div className="row">
                  <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 mt-2 d-flex justify-content-center">
                    <img
                      src={require(`../Assets/Images/ads1.png`)}
                      style={{ height: 200, borderRadius: 15, width: '100%' }}
                    />
                  </div>
                  <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 mt-2 d-flex justify-content-center">
                    <img
                      src={require(`../Assets/Images/ads2.png`)}
                      style={{ height: 200, borderRadius: 15, width: '100%' }}
                    />
                  </div>
                  <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 mt-2 d-flex justify-content-center">
                    <img
                      src={require(`../Assets/Images/ads3.jpg`)}
                      style={{ borderRadius: 15, height: 200, width: '100%' }}
                    />
                  </div>
                </div>
                {/* <OwlCarousel
                  key={"banner1"}
                  className="premium-carousel-v1"
                  {...settings}
                  slidesToShow={2}
                  slidesToScroll={1}
                  initialSlide={0}
                >
                  {[1, 2, 3].map((item) => {
                    return (
                      <div
                        key={item}
                        className="col-xl-6 col-lg-6 col-md-6 col-sm-12 p-2"
                      >
                        <img
                          src={require(`../Assets/Images/ads${item}.jpg`)}
                          style={{ borderRadius: 15 }}
                        />
                      </div>
                    );
                  })}
                </OwlCarousel> */}
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="sptb bg-white">
        <div className="container">
          <div className="section-title center-block text-center">
            <h2 className="text-underline text-bold fs-30">Hire Smarter:
              How Happie Dealz Overcomes Traditional Recruitment</h2>
            {/* <p>
              Mauris ut cursus nunc. Morbi eleifend, ligula at consectetur
              vehicula
            </p> */}
          </div>
          <div className="item-all-cat center-block text-center">
            <div className="row">
              <div className="col-lg-12 col-md-12">
                <div className="card">
                  <div className="card-header">
                    <div className="card-header-img w-100 d-flex justify-content-center">
                      <img src={aboutdescription} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="sptb bg-white">
        <div className="container">
          <div className="section-title center-block text-center">
            <h2 className="text-underline text-bold fs-30">Benefits for Business</h2>
            {/* <p>
              Mauris ut cursus nunc. Morbi eleifend, ligula at consectetur
              vehicula
            </p> */}
          </div>
          <div className="item-all-cat center-block text-center">
            <div className="row">
              <div className="col-lg-4 col-md-12">
                <div className="card h-100">
                  <div className="card-header">
                    <div className="card-header-img mb-5 w-100 d-flex justify-content-center">
                      <img src={require("../Assets/Images/au1.png")} />
                    </div>
                  </div>
                  <div className="card-body text-center">
                    <h3 className="mt-2 mb-2 text-bold">Cost Control</h3>
                    <p className="text-muted mb-0 fs-18 about-content" id="about1content">
                      Access skilled freelance
                      marketers through a simple
                      subscription—without
                      employment overheads or
                      hidden platform fees.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-12">
                <div className="card h-100">
                  <div className="card-header">
                    <div className="card-header-img mb-5 w-100 d-flex justify-content-center">
                      <img src={require("../Assets/Images/au2.png")} />
                    </div>
                  </div>
                  <div className="card-body text-center">
                    <h3 className="mt-2 mb-2 text-bold">Faster Market Reach</h3>
                    <p className="text-muted mb-0 fs-18 about-content" id="about2content">
                      Connect directly with
                      experienced marketers to
                      promote your products and
                      services efficiently.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-12">
                <div className="card  h-100">
                  <div className="card-header">
                    <div className="card-header-img mb-5 w-100 d-flex justify-content-center">
                      <img src={require("../Assets/Images/au3.png")} />
                    </div>
                  </div>
                  <div className="card-body text-center">
                    <h3 className="mt-2 mb-2 text-bold">One Platform, Clear Process</h3>
                    <p className="text-muted mb-0 fs-18 about-content" id="about3content">
                      A transparent space to
                      discover, connect, and
                      collaborate with marketing
                      professionals worldwide.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="sptb">
        <div className="container">
          <div className="section-title center-block text-center">
            <h2 className="text-underline text-bold fs-30">
              The Benefits for Freelance Marketers
            </h2>
            <p>Work independently. Connect globally. Grow on your terms.</p>
          </div>
          <div class="row ">
            <div class="col-md-6 col-lg-4 features">
              <div class="card h-100">
                <div class="item-card">
                  <div class="item-card-desc">
                    <div class="item-card-img">
                      <img
                        src={require("../Assets/Images/fm1.png")}
                        className="rounded-top-7"
                      />
                    </div>
                  </div>
                </div>
                <div class="card-body text-center">
                  <div class="feature">
                    {/* <div class="fa-stack fa-lg  fea-icon bg-success mb-3">
                      <i class="fa fa-bullhorn  text-white"></i>
                    </div> */}

                    <h3 className="mb-2 text-bold">
                      Work Freedom
                    </h3>
                    <p className="mt-3 fs-18 about-content" id="about4content">
                      Choose projects across
                      industries and work
                      directly with businesses.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-lg-4 features">
              <div class="card h-100">
                <div class="item-card">
                  <div class="item-card-desc">
                    <div class="item-card-img">
                      <img
                        src={require("../Assets/Images/fm2.png")}
                        className="rounded-top-7"
                      />
                    </div>
                  </div>
                </div>
                <div class="card-body text-center">
                  <div class="feature">
                    <h3 class="mb-2 text-bold">Earning Potential</h3>
                    <p className="mt-3 fs-18 about-content" id="about5content">
                      Set your own terms and
                      grow your income based on
                      skill and effort.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-lg-4 features">
              <div class="card h-100">
                <div class="item-card">
                  <div class="item-card-desc">
                    <div class="item-card-img">
                      <img
                        src={require("../Assets/Images/fm3.png")}
                        className="rounded-top-7"
                      />
                    </div>
                  </div>
                </div>
                <div class="card-body text-center">
                  <div class="feature">
                    <h3 class="mb-2 text-bold">
                      Professional Growth
                    </h3>
                    <p className="mt-3 fs-18 about-content" id="about6content">
                      Build experience, expand
                      your network, and
                      collaborate with businesses
                      across markets.
                    </p>
                  </div>
                </div>
              </div>
            </div>

          </div>
          {/* <OwlCarousel
            key={"freelancers"}
            className="premium-carousel-v5"
            {...settings}
          >
            {freeLancers.map((item) => {
              return (
                <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 p-1">
                  {item.usertypecategory === "Individual" ? (
                    <IndividualGrid item={item} />
                  ) : (
                    <CompanyGrid item={item} />
                  )}
                </div>
              );
            })}
          </OwlCarousel> */}
        </div>
      </section>
      <section class="sptb bg-white">
        <div class="container">
          <div class="section-title center-block text-center">
            <h2 className="text-underline text-bold fs-30">
              Why Happie Dealz ?
            </h2>
          </div>
          <div class="row ">
            <div class="col-md-6 col-lg-4 features">
              <div class="card h-100">
                <div className="item-card">
                  <div className="item-card-img">
                    <img src={require("../Assets/Images/oe1.png")} />
                  </div>
                </div>
                <div class="card-body text-center">
                  <div class="feature">
                    <h3 className="text-bold">Marketing-Focused
                      Platform</h3>
                    <p className=" fs-18">
                      Built exclusively to
                      connect businesses and
                      freelance marketers.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-lg-4 features">
              <div class="card h-100">
                <div className="item-card">
                  <div className="item-card-img">
                    <img src={require("../Assets/Images/oe2.png")} />
                  </div>
                </div>

                <div class="card-body text-center">
                  <div className="feature">
                    <h3 className="text-bold">Subscription-Based
                      Pricing</h3>
                    <p className=" fs-18">
                      Simple, upfront pricing with
                      no markups or additional
                      charges from the platform.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-lg-4 features">
              <div class="card h-100">
                <div className="item-card">
                  <div className="item-card-img">
                    <img src={require("../Assets/Images/oe3.png")} />
                  </div>
                </div>
                <div class="card-body text-center">
                  <div class="feature">
                    <h3 className="text-bold">Easy-to-Use
                      Experience</h3>
                    <p className=" fs-18">
                      Designed for clear
                      discovery, direct
                      connections, and smooth
                      collaboration.
                    </p>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>


      {/* <section className="sptb bg-white">
        <div className="container">
          <OwlCarousel
            key={"banner2"}
            className="premium-carousel-v1"
            {...settings}
            slidesToShow={3}
            slidesToScroll={1}
            initialSlide={0}
          >
            {[1, 2, 3, 4].map((item) => {
              return (
                <div
                  key={item}
                  className="col-xl-4 col-lg-4 col-md-6 col-sm-12 p-2"
                >
                  <img
                    src={require(`../Assets/Images/ads${item + 3}.jpeg`)}
                    style={{ borderRadius: 15 }}
                  />
                </div>
              );
            })}
          </OwlCarousel>
        </div>
      </section> */}
      <section className="sptb bg-white">
        <div className="container">
          <OwlCarousel
            key={"banner2"}
            className="premium-carousel-v1"
            {...settings}
            slidesToShow={3}
            slidesToScroll={1}
            initialSlide={0}
          >
            {images.map((filename, index) => (
              <div
                key={index}
                className="col-xl-4 col-lg-4 col-md-6 col-sm-12 p-2"
              >
                <img
                  src={require(`../Assets/Images/${filename}`)}
                  style={{ borderRadius: 15 }}
                  width={350} height={190}
                />
              </div>
            ))}
          </OwlCarousel>
        </div>
      </section>
      <section class="sptb position-relative pattern">
        <div className="container">
          <div class="section-title center-block text-center">
            <h1 class="text-white position-relative text-bold">Testimonials</h1>
            <h5 class="text-white position-relative  text-bold">
              Don’t just take our word for it! Here’s what our users have to
              say:
            </h5>
          </div>
          <div className="row">
            <div className="col-md-12">
              <OwlCarousel
                key={"providers"}
                className="premium-carousel-v5"
                {...{
                  dots: false,
                  autoplay: true,
                  autoplaySpeed: 5000,
                  infinite: true,
                  speed: 500,
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  initialSlide: 0,
                }}
              >
                <div class="item text-center">
                  <div class="row">
                    <div class="col-xl-8 col-md-12 d-block mx-auto">
                      <div class="testimonia">
                        <p class="text-white">
                          <i class="fa fa-quote-left text-white"></i>
                          Being a part of Happie Dealz as a freelance marketer has been an amazing
                          journey! The platform gave me the perfect space to connect with genuine
                          businesses and promote their products with ease. The tools, support, and
                          guidance provided by the Happie Dealz team helped me grow both
                          professionally and financially. I love the flexibility of working on my own
                          schedule while still being part of a strong, supportive network. Happie
                          Dealz truly lives up to its name — it’s all about creating happy deals for
                          marketers and businesses alike!
                          <i class="fa fa-quote-right text-white"></i>
                        </p>
                        <h6 class="title">— Bhuvana, Freelance Marketer at Happie Dealz</h6>
                        {/* <span class="post">Business Owner</span> */}
                        <div class="rating-star">
                          {[1, 2, 3, 4, 5].map((item1) => {
                            return (
                              <i
                                key={item1}
                                class="fa fa-star text-warning"
                              ></i>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="item text-center">
                  <div class="row">
                    <div class="col-xl-8 col-md-12 d-block mx-auto">
                      <div class="testimonia">
                        <p class="text-white-80">
                          <i class="fa fa-quote-left text-white-80"></i>
                          Happie Dealz is a great platform to connect with freelance marketers. It
                          helped us find the right people to promote our services and grow our
                          business. The site is easy to use, and the team is very supportive. We’re
                          happy to be part of Happie Dealz!
                          <i class="fa fa-quote-right text-white-80"></i>
                        </p>
                        <h6 class="title">— Team Happie Info Tech (HIT)</h6>
                        {/* <span class="post">Digital Marketing Expert</span> */}
                        <div class="rating-star">
                          {[1, 2, 3, 4, 5].map((item1) => {
                            return (
                              <i
                                key={item1}
                                class="fa fa-star text-warning"
                              ></i>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="item text-center">
                  <div class="row">
                    <div class="col-xl-8 col-md-12 d-block mx-auto">
                      <div class="testimonia">
                        <p class="text-white-80">
                          <i class="fa fa-quote-left text-white-80"></i>
                          I’m really happy to be part of Happie Dealz! The platform helped me connect
                          with good businesses and earn through marketing. It’s easy to use, and the
                          team always supports me whenever I need help. Happie Dealz has given me
                          confidence and new opportunities to grow.
                          <i class="fa fa-quote-right text-white-80"></i>
                        </p>
                        <h6 class="title">— Shalini, Freelance Marketer at Happie Dealz</h6>
                        {/* <span class="post">Digital Marketing Expert</span> */}
                        <div class="rating-star">
                          {[1, 2, 3, 4, 5].map((item1) => {
                            return (
                              <i
                                key={item1}
                                class="fa fa-star text-warning"
                              ></i>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="item text-center">
                  <div class="row">
                    <div class="col-xl-8 col-md-12 d-block mx-auto">
                      <div class="testimonia">
                        <p class="text-white-80">
                          <i class="fa fa-quote-left text-white-80"></i>
                          Happie Dealz has been a great experience for me. I got the chance to work
                          with different businesses and learn new marketing skills. The platform is
                          easy to use, and the team is very supportive. I’m proud to be a part of
                          Happie Dealz and grow as a freelance marketer.
                          <i class="fa fa-quote-right text-white-80"></i>
                        </p>
                        <h6 class="title">—  Dharanee, Freelance Marketer at Happie Dealz</h6>
                        {/* <span class="post">Digital Marketing Expert</span> */}
                        <div class="rating-star">
                          {[1, 2, 3, 4, 5].map((item1) => {
                            return (
                              <i
                                key={item1}
                                class="fa fa-star text-warning"
                              ></i>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </OwlCarousel>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Home;
